import { useEffect } from 'react';

export const useSchemaGUISync = (
    watch: any,
    setValue: any,
    schemaObject: any
) => {

    useEffect(() => {
        if (!schemaObject) return;

        const currentValue = watch('value');
        if (!currentValue) return;

        try {
            const parsedValue = JSON.parse(currentValue);
            Object.keys(parsedValue).forEach(key => {
                setValue(`schemaGUI.${key}`, parsedValue[key], { shouldValidate: false });
            });
        } catch (error) {
            console.error('Failed to parse initial value:', error);
        }
    }, [schemaObject]);

    // Sync schemaGUI -> value (JSON)
    useEffect(() => {
        const subscription = watch((formData: any, { name }: any) => {
            if (name?.startsWith('schemaGUI.')) {
                try {
                    const typedSchemaGUI: Record<string, any> = {};

                    Object.entries(formData.schemaGUI || {}).forEach(([key, value]) => {
                        const propertySchema = schemaObject?.properties[key];

                        if (propertySchema?.type === 'integer' || propertySchema?.type === 'number') {
                            typedSchemaGUI[key] = value === '' || value === null ? undefined : Number(value);
                        } else if (propertySchema?.type === 'boolean') {
                            typedSchemaGUI[key] = Boolean(value);
                        } else {
                            typedSchemaGUI[key] = value;
                        }
                    });

                    const jsonValue = JSON.stringify(typedSchemaGUI, null, 2);
                    setValue('value', jsonValue, { shouldValidate: false });
                } catch (error) {
                    console.error('Failed to stringify schemaGUI:', error);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, setValue, schemaObject]);

    // Sync value (JSON) -> schemaGUI
    useEffect(() => {
        const subscription = watch((formData: any, { name }: any) => {
            if (name === 'value') {
                try {
                    const parsedValue = JSON.parse(formData.value || '{}');

                    if (JSON.stringify(parsedValue) !== JSON.stringify(formData.schemaGUI)) {
                        const typedValue: Record<string, any> = {};

                        Object.entries(parsedValue).forEach(([key, value]) => {
                            const propertySchema = schemaObject?.properties?.[key];

                            if (propertySchema?.type === 'integer' || propertySchema?.type === 'number') {
                                typedValue[key] = value === '' ? undefined : Number(value);
                            } else if (propertySchema?.type === 'boolean') {
                                typedValue[key] = Boolean(value);
                            } else {
                                typedValue[key] = value;
                            }
                        });

                        setValue('schemaGUI', typedValue, { shouldValidate: false });
                    }
                } catch (error) {
                    console.error('Failed to parse value:', error);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, setValue, schemaObject]);
};